import * as accountingBooks from "./accounting-books";

export default [
    accountingBooks
]



// WEBPACK FOOTER //
// ./src/store/modules/record-management/index.js